// extracted by mini-css-extract-plugin
export var chip = "_et-0";
export var filterDropdown = "_et-5";
export var filterItem = "_et-6";
export var icon = "_et-1";
export var removeButton = "_et-3";
export var removeIcon = "_et-4";
export var separator = "_et-2";